import { useState } from "react";
import AppHeader from "@/components/AppHeader";
import NewReportForm from "@/components/NewReportForm";
import SavedAccounts from "@/components/SavedAccounts";
import Footer from "@/components/Footer";

const Stat = ({ label, value, hint }) => (
  <div className="bg-[#141414] border border-[#262626] rounded-sm p-4">
    <div className="kpi-label">{label}</div>
    <div className="font-mono-data text-2xl text-white mt-1.5 tracking-tight">{value}</div>
    {hint && <div className="text-xs text-[#737373] mt-1">{hint}</div>}
  </div>
);

export default function Dashboard() {
  const [refreshKey] = useState(0);

  return (
    <div className="min-h-screen radar-grid-bg">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-6 md:px-8 py-10 md:py-14">
        <section className="mb-10">
          <div className="kpi-label mb-3">/ COMMAND CENTER · ENGINEERING SERVICES</div>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter text-white max-w-3xl leading-[1.05]">
            Pursue every dollar of <span className="text-[#0A84FF]">engineering</span>,<br/>
            <span className="text-[#737373]">manufacturing & digital</span> spend with surgical precision.
          </h1>
          <p className="text-[#A3A3A3] mt-5 max-w-2xl text-[15px] leading-relaxed">
            RADAR turns any company name into a 21-section, executive-grade account intelligence
            report — financial signals, strategic priorities, technology stack, deal opportunities,
            CXO outreach, and a live CRM pipeline entry.
          </p>
        </section>

        <section className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10" data-testid="stats-row">
          <Stat label="Sections / Report" value="21" hint="Executive-ready" />
          <Stat label="Engine" value="Claude Haiku" hint="4.5 · long-form" />
          <Stat label="Avg. Time" value="60-90s" hint="End-to-end" />
          <Stat label="Output" value="JSON · PDF · Email" hint="Multi-channel ready" />
        </section>

        <section id="new-report" className="mb-12">
          <NewReportForm />
        </section>

        <section>
          <div className="flex items-baseline justify-between mb-4">
            <div>
              <div className="kpi-label">/ INTELLIGENCE LIBRARY</div>
              <h2 className="font-display text-2xl text-white tracking-tight mt-1">Saved Accounts</h2>
            </div>
            <span className="kpi-label hidden md:inline">CLICK ROW TO OPEN</span>
          </div>
          <SavedAccounts refreshKey={refreshKey} />
        </section>
      </main>
      <Footer />
    </div>
  );
}
